export default __webpack_public_path__ + "58e804b0da07855ff9adffbc14d4ab56.png";